var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrossSmallGold = function SvgIconCrossSmallGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.855 8.03-.886-.886L4.113 4 .969.877l.886-.887 3.144 3.145L8.123-.01l.886.887L5.865 4l3.144 3.144-.886.886-3.124-3.144z"
  })));
};
export default SvgIconCrossSmallGold;